"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgDirectionCircleDownLeft = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M12 12v8m0 0h8m-8 0L25.333 6.667m3.548 5.88a13.33 13.33 0 0 1-3.453 12.881c-5.207 5.207-13.65 5.207-18.856 0s-5.207-13.649 0-18.856a13.33 13.33 0 0 1 12.88-3.453" }))); };
exports.default = SvgDirectionCircleDownLeft;
//# sourceMappingURL=DirectionCircleDownLeft.js.map